import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'infoButtonLabel'
  | 'errorIconAriaLabel'
  | 'closeButtonAriaLabel';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  infoButtonLabel: {
    defaultMessage: 'Learn More',
    description: 'Label for info button in error modal',
    id: 'boxFileRequest.formErrorNotification.buttonLabel',
  },
  errorIconAriaLabel: {
    defaultMessage: 'Error icon',
    description: 'Aria-label of error icon',
    id: 'boxFileRequest.formErrorNotification.errorIconAriaLabel',
  },
  closeButtonAriaLabel: {
    defaultMessage: 'Clear Notification',
    description: 'Aria-label of close notification button',
    id: 'boxFileRequest.formErrorNotification.closeButtonAriaLabel',
  },
});

export default messages;
